import { Component } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Button } from './ui/button';

export default class SubmitErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error('Submit page render failure:', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gradient-to-b from-orange-50 via-white to-slate-50 px-4 py-16">
          <div className="mx-auto max-w-xl rounded-3xl border border-orange-200 bg-white p-8 text-center shadow-lg">
            <AlertTriangle className="mx-auto mb-4 h-10 w-10 text-orange-500" />
            <h1 className="mb-2 text-2xl font-bold text-slate-900">Submit page recovered</h1>
            <p className="mb-6 text-slate-600">
              The form hit a runtime error and was reset. You can continue with a fresh submit view.
            </p>
            <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
              <Button
                type="button"
                className="bg-orange-500 hover:bg-orange-600"
                onClick={() => this.setState({ hasError: false })}
              >
                Reload form
              </Button>
              <Button type="button" variant="outline" asChild>
                <Link to="/">Back home</Link>
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
